// English dictionary — the site's default language.
// Keys are grouped per page/section; keep en.js and sk.js structurally identical.
const en = {
  nav: {
    info: 'INFO',
  },

  hero: {
    subtitle: 'Experience badminton tournaments in beautiful city of Trenčín',
    info: 'INFO',
    book: 'BOOK ACCOMMODATION',
  },

  home: {
    upcomingTitle: 'Upcoming events in 2026',
    u15Card: 'SLOVAK YOUTH Badminton Europe U15 circuit',
    u17Card: 'SLOVAK YOUTH Badminton Europe U17 circuit',
    u13Card: 'SLOVAK YOUTH Badminton Europe U13 circuit',
    labelUpcoming: 'Upcoming',
    eventDateShort: '25-27th September',
  },

  tournament: {
    entryDeadline: 'Entry deadline:',
    upcoming: 'Upcoming',
    deadlineU17: '25th August 2026',
    deadlineU13: '11th September 2026',
    eventDate: '25-27th September 2026',
    invitation: 'INVITATION',
    register: 'REGISTER',
    draws: 'DRAWS',
    acceptanceList: 'ACCEPTANCE LIST',
    infoTitle: 'Tournament information',
    entryFees: 'Entry fees:',
    singles25: 'Singles = 25€',
    singles40: 'Singles = 40€',
    doubles20: 'Doubles = 20€ per player',
    doubles30: 'Doubles = 30€ per player',
    feesPayment: 'Entry fees have to be paid by bank transfer before the event or in cash (EUR) to the organizer during the event.',
    shuttlesLabel: 'Official brand of shuttles:',
    shuttlesBrand: 'KAWASAKI SHUTTLECOCK TEAM 1',
    shuttlesText: '2 shuttles will be provided per match, afterwards the participants will supply shuttles by themselves. KAWASAKI SHUTTLECOCK TEAM 1 can be acquired from the organisers.',
    managersMeeting: 'Team Managers meeting:',
    meetingU17: 'Thursday September 24, 2026 at 7 p.m. in the venue.',
    mainEvent: 'Main event',
    finals: 'Finals',
    provisionalNote: 'ⓘ Provisional times can be changed subject to the number of entries. The final frame schedule (with the exact planned conclusion of all matches) shall be made at least 20 days before the start of the tournament and shall be published on the website.',
    seedingNote: 'The seeding and the draw have been done according to the BEC European U17 Ranking from 17th September.',
    koSystemNote: 'Singles will be played in groups in first stage, then by KO system, doubles will be played by KO system. In the event of any dispute, the Referee´s decision shall be final.',
    day25: '25th September',
    day26: '26th September',
    day27: '27th September',
  },

  info: {
    heroTitle: 'Information',
    contactsTitle: 'Contacts & Location',
    director: 'Tournaments Director:',
    contactPerson: 'Contact Person:',
    phoneNumber: 'Phone number:',
    email: 'Email:',
    venue: 'Venue:',
    transportTitle: 'Transport',
    transportIntro: 'Organizer provides a transport for a fee from:',
    transportDetails: 'Send your travel details to sj.bedminton@gmail.com as soon as possible. Transport fees have to be paid by bank transfer before the event or in cash (EUR) to the organizer during the event.',
    transportWalking: 'All official hotels are walking distance to the venue and therefore transport between venue and hotels is not provided.',
    mealsDesc: 'Restaurant is a part of the venue. Lunch and dinner are provided in the form of buffet offering variety of meals – all you can eat:',
    transportBa: 'BRATISLAVA International Airport = 30€/person/one way',
    transportVie: 'VIENNA International Airport = 40€/person/one way',
    accomTitle: 'Accomodation',
    accomOrder: 'Accommodation is ordered directly via our online booking form.',
    accomPayment: 'Hotel bills have to be paid by bank transfer before the tournament or in cash (EUR) immediately after your arrival to the organizer in the sports hall. You have to pay for the room, not for person.',
    breakfastIncluded: 'Breakfast included',
    doubleRoom85: 'Double room = 85€/night',
    tripleRoom100: 'Tripple room = 100€/night',
    fourRoom110: '4-person room room = 110€/night',
    doubleRoom95: 'Double room = 95€/night',
    tripleRoom110: 'Tripple room = 110€/night',
    singleRoom65: 'Single room = 65€/night',
    apartment170: 'Apartment (2-4 persons) = 170€/night',
    apartmentMinStay: 'Minimum stay = 3 nights. Breakfast included.',
    apartmentDesc: 'Apartment includes: 2 separate double rooms, bathroom, kitchen, living room, washing machine.',
    distVenue: 'Located directly in the venue.',
    dist14: 'Located 1,4km from the venue.',
    dist19: 'Located 1,9km from the venue.',
    servicesTitle: 'Other Services',
    stringing: 'Stringing:',
    stringingAvail: 'Available all the time during the event:',
    stringingOnly: 'Stringing only = 10€',
    stringingNew: 'Stringing + new string = 18€',
    meals: 'Meals:',
    lunch: 'Lunch = 12€',
    dinner: 'Dinner = 12€',
  },

  booking: {
    headerTitle: 'Book accommodation',
    headerSub: 'Slovak Junior & Youth · Trenčín',
    step1Title: 'Select your tournament',
    underAge: (age) => `Under ${age}`,
    contactTitle: 'Contact information',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',
    email: 'Email',
    emailInvalid: 'Please enter a valid email address',
    selectCountry: 'Select country',
    searchCountry: 'Search country…',
    chooseHotel: 'Choose a hotel',
    checkingAvail: 'checking availability…',
    availUnknown: 'Availability could not be verified — shown counts may be out of date.',
    unavailable: 'Unavailable',
    selfCatering: 'Self-catering',
    breakfast: 'Breakfast included',
    atVenue: 'At the venue · 0 km',
    fromVenue14: '1.4 km from venue',
    fromVenue19: '1.9 km from venue',
    rooms: 'Rooms',
    perNight: '€ / night',
    addRoom: 'Add room',
    soldOut: 'Sold out',
    minNights3: 'Apartments require a minimum stay of 3 nights.',
    noRoomsLeft: 'No rooms left at this hotel',
    onlyRoomsLeft: (n) => `Only ${n} room${n > 1 ? 's' : ''} left at this hotel`,
    roomsAvailable: (n, total) => `${n} of ${total} rooms available`,
    selectedRooms: 'Selected rooms',
    remove: 'Remove',
    checkin: 'Check-in',
    checkout: 'Check-out',
    nights: (n) => `${n} night${n > 1 ? 's' : ''}`,
    personFirst: (i) => i === 1 ? 'First name (person 1)' : `First name (person ${i}, optional)`,
    personLast: (i) => i === 1 ? 'Last name (person 1)' : `Last name (person ${i}, optional)`,
    addAnotherRoom: 'Add another room',
    summaryTitle: 'Reservation summary',
    tournamentLabel: 'Tournament:',
    hotelLabel: 'Hotel:',
    contactLabel: 'Contact:',
    phoneLabel: 'Phone:',
    emailLabel: 'Email:',
    person: 'Person',
    estimatedTotal: 'Total',
    paymentNote: 'Payment is due by bank transfer before the tournament or in cash (EUR) on arrival. You pay per room, not per person.',
    overFull: (hotel) => `${hotel} has just sold out — please go back and pick another hotel.`,
    overSome: (n, hotel, remove) => `Only ${n} room${n > 1 ? 's' : ''} left at ${hotel} — please remove ${remove} room${remove > 1 ? 's' : ''} or pick another hotel.`,
    btnContact: 'Contact info',
    btnHotel: 'Select hotel',
    btnRoom: 'Select room',
    btnGuests: 'Add guests',
    btnReview: 'Review & submit',
    btnSubmit: 'Submit reservation',
    btnSubmitting: 'Submitting…',
    btnBack: 'Back',
    btnClose: 'Close',
    successTitle: 'Reservation submitted!',
    successText: 'Your accommodation request has been received. The organizer will confirm and send payment instructions to your email.',
    confirmHotelChange: 'Changing hotel will clear your selected rooms. Continue?',
    submitError: 'Sorry, something went wrong sending your reservation. Please try again.',
    roomTypes: {
      'Single room': 'Single room',
      'Double room': 'Double room',
      'Triple room': 'Triple room',
      '4-person room': '4-person room',
      'Apartment (2-4 persons)': 'Apartment (2-4 persons)',
    },
  },

  reg: {
    notOpen: 'Registration is not open yet.',
    headerTitle: 'Tournament registration',
    step1Title: 'Club & contact',
    club: 'Club name',
    country: 'Country',
    managerTitle: 'Team manager',
    singlesTitle: 'Singles entries',
    doublesTitle: 'Doubles entries',
    addSingles: 'Add singles player',
    addDoubles: 'Add doubles pair',
    noEntries: 'No entries yet — you can skip this step.',
    player1: 'Player 1',
    player2opt: 'Player 2 (optional)',
    partnerNote: 'A doubles entry is valid with one player — the partner can be added later.',
    discipline: 'Discipline',
    disciplines: {
      BS: "Boys' singles",
      GS: "Girls' singles",
      BD: "Boys' doubles",
      GD: "Girls' doubles",
      XD: 'Mixed doubles',
    },
    summaryTitle: 'Registration summary',
    clubLabel: 'Club:',
    entriesLabel: 'Entries:',
    entriesCount: (n) => `${n} ${n === 1 ? 'entry' : 'entries'}`,
    needOneEntry: 'Add at least one entry (singles or doubles) before submitting.',
    btnSingles: 'Singles entries',
    btnDoubles: 'Doubles entries',
    btnSubmit: 'Submit registration',
    successTitle: 'Registration sent!',
    successText: 'Your entries were received. The organizer will confirm your registration by email.',
  },
};

export default en;
